var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "point-flag"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 16,
    height: 16,
    transform: "translate(123 760)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_80",
    "data-name": "Mask Group 80",
    transform: "translate(-123 -760)",
    clipPath: "url(#point-flag)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_64_",
    "data-name": "svgexport-6 (64)",
    transform: "translate(121.824 758.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_30-Checked",
    "data-name": "30-Checked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M7.521,14.817l-.155-.263C6.208,12.58,3.125,8.385,3.094,8.343L3,8.22,4.163,7.075,7.482,9.392A38.177,38.177,0,0,1,12.767,3.77,19.216,19.216,0,0,1,15.09,2.014l.042-.025h2.043L16.83,2.3c-4.37,3.892-9.11,12.172-9.158,12.255Z",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_13-Cancel",
    "data-name": "13-Cancel"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(7.241 3.658)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(7.241 15.801)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_270",
    "data-name": "Ellipse 270",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(1.176 9.729)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_271",
    "data-name": "Ellipse 271",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(13.306 9.729)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(2.947 14.023)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_273",
    "data-name": "Ellipse 273",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(2.952 5.441)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_274",
    "data-name": "Ellipse 274",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(11.529 14.018)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_275",
    "data-name": "Ellipse 275",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(1.982 6.694)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(12.499 12.765)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_277",
    "data-name": "Ellipse 277",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(4.208 14.982)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_278",
    "data-name": "Ellipse 278",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(5.669 3.865)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_279",
    "data-name": "Ellipse 279",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(8.812 15.594)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(1.382 11.299)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(13.099 8.16)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_282",
    "data-name": "Ellipse 282",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(1.982 12.765)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(10.273 14.982)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(4.208 4.477)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_285",
    "data-name": "Ellipse 285",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(8.812 3.865)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_286",
    "data-name": "Ellipse 286",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(5.669 15.594)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_287",
    "data-name": "Ellipse 287",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(13.099 11.299)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    cx: 0.281,
    cy: 0.281,
    r: 0.281,
    transform: "translate(1.382 8.16)",
    fill: "#7e59d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointFlag);
export default __webpack_public_path__ + "static/media/point-flag.392d8e03791e68505772a83340477f05.svg";
export { ForwardRef as ReactComponent };